// Svelte 5 no longer needs svelte/store imports for basic reactivity

// Create reactive state for the player
export const playerState = $state({
    duration: false,
    time: 0,
    speed: 1,
    playing: false,
    adVolume: 1,
    programVolume: 1,
    /* Optional stem tracks (projectState.media.stems) mixed under the video */
    backgroundVolume: 1,
    foregroundVolume: 1,
    previewEvent: -1,
    previewPlaying: false,
    /** @type {"videojs" | "framelight"} */
    engine: "videojs",
    flxEmbedUrl: "",
    flxPlayerBaseUrl: "",
    flxMaterialId: "",
});

// Function to update current playback time
export function updateTime(time) {
    playerState.time = time;
}

// Function to update media duration
export function updateDuration(duration) {
    playerState.duration = duration;
    playerState.playing = duration ? true : false;
}

// Function to update playing status
export function updatePlayingStatus(status) {
    playerState.playing = status;
}

// Function to update playback speed
export function updatePlayerSpeed(speed) {
    playerState.speed = speed;
}

export function updatePreviewEvent(eventIndex) {
    playerState.previewEvent = eventIndex;
}

/**
 * Switch between Video.js and Framelight X / SCS player engines.
 * @param {"videojs" | "framelight"} engine
 * @param {{ embedUrl?: string, playerBaseUrl?: string, materialId?: string }} [flx]
 */
export function setPlayerEngine(engine, flx = {}) {
    playerState.engine = engine;
    if (engine === "framelight") {
        playerState.flxEmbedUrl = flx.embedUrl || "";
        playerState.flxPlayerBaseUrl = flx.playerBaseUrl || "";
        playerState.flxMaterialId = flx.materialId || "";
        playerState.time = 0;
        playerState.playing = false;
        playerState.duration = false;
    } else {
        playerState.flxEmbedUrl = "";
        playerState.flxPlayerBaseUrl = "";
        playerState.flxMaterialId = "";
    }
}
